import React from 'react';

import { StagesMenuLayerItem } from '../../types';
import { MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import LayerMenuItem from '../LayerMenuItem';

import styles from '../../styles/LeftMenu.module.scss';

type StageMenuItemProps = {
  entry: StagesMenuLayerItem;
};

const StageMenuItem: React.FC<StageMenuItemProps> = ({ entry }) => {
  return (
    <LayerMenuItem
      className={styles.stageMenuItem}
      entry={entry}
      testDataAttributes={{
        'data-test': 'layer-menu-item',
        'data-test-item-type': MENU_ITEM_TYPE.STAGE,
        'data-test-item-key': entry.key,
        'data-test-item-active': entry.active ? 'active' : undefined,
      }} />
  );
};

export default StageMenuItem;
